// extracted by mini-css-extract-plugin
module.exports = {"root":"ShowUrlAliasPage_root__1XPCB","loading":"ShowUrlAliasPage_loading__1bIaQ","right":"ShowUrlAliasPage_right__21r8N","noMargin":"ShowUrlAliasPage_noMargin__3cvIT"};